import { FC, memo } from 'react'
import { Tabs } from 'antd'
import type { TabsProps } from 'antd'
import { useTranslation } from '@/services/i18n'
import styles from './index.module.scss'
import TxRecord from '@/views/History/pannels/TxRecord'
import MpcSign from './pannels/MpcSign'
import Webrecord from './pannels/WebRecord'
import { useLocation } from 'react-router-dom'

const History: FC = () => {
  const { t } = useTranslation()
  const items: TabsProps['items'] = [
    {
      key: 'txRecords',
      label: t('record.txRecord'),
      children: <TxRecord />,
    },
    {
      key: 'mpcSignRecords',
      label: t('record.mpcSign'),
      children: <MpcSign />,
    },
    {
      key: 'web3Records',
      label: t('record.web3record'),
      children: <Webrecord />,
    },
  ]
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const getActiveTab = () => {
    if (searchParams.get('tab') === '2') {
      return 'mpcSignRecords'
    } else {
      return 'txRecords'
    }
  }

  return (
    <div className={styles.container}>
      <Tabs
        items={items}
        size="large"
        className={styles.tabs}
        animated={true}
        destroyInactiveTabPane={true}
        defaultActiveKey={getActiveTab()}
      />
    </div>
  )
}

export default memo(History)
